import { Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AdminSignin } from '../../features/auth/authSlice';
import Spinner from '../../components/UIElements/Spinner';
const schema = Yup.object({
  emailId: Yup.string().email('Invalid email').required('Email is Required'),
  password: Yup.string().required('Enter Password'),
});
const AdminSignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  return (
    <main className='size-full flex flex-col items-center justify-center md:px-4'>
      <Formik
        initialValues={{
          emailId: '',
          password: '',
        }}
        validationSchema={schema}
        onSubmit={async (values) => {
          try {
            setLoading(true);
            const response = await dispatch(AdminSignin(values)).unwrap();
            if (response.status === 200) {
              localStorage.setItem(
                'access_token',
                response?.data?.access_token,
              );
              navigate('/admin/dashboard');
            }
          } catch (error) {
            console.log(error);
            if (error?.status === 401) {
              setError('Invalid Credentials! Enter Valid Details');
            } else {
              setError('Something went wrong. Please try again.');
            }
          } finally {
            setLoading(false);
          }
        }}
      >
        {() => (
          <div className='max-w-sm w-full text-gray-600  bg-white border p-6 lg:p-10 rounded-xl'>
            <div className='text-center mb-4'>
              <img
                src='/images/SVClassEdge.png'
                className='max-h-24 h-auto block w-[300px] object-contain '
              ></img>
              <div className='space-y-2 mt-2 '>
                <h6 className='text-gray-800 text-2xl font-semibold '>
                  Log in to admin account
                </h6>
              </div>
            </div>
            <Form className='max-w-sm relative'>
              <div className='text-center text-red-600 mb-2 font-semibold'>
                {error}
              </div>
              <div>
                <label className='font-medium'>Email</label>
                <Field name='emailId'>
                  {({ field }) => (
                    <input
                      {...field}
                      type='email'
                      className='w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-[#3f5eb5] shadow-sm rounded-lg'
                    />
                  )}
                </Field>
                <ErrorMessage
                  name='emailId'
                  component='div'
                  className='text-red-600 text-sm mt-1'
                />
              </div>
              <div className='mt-2'>
                <label className='font-medium'>Password</label>
                <Field name='password'>
                  {({ field }) => (
                    <input
                      {...field}
                      type='password'
                      className='w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-[#3f5eb5] shadow-sm rounded-lg'
                    />
                  )}
                </Field>
                <ErrorMessage
                  name='password'
                  component='div'
                  className='text-red-600 text-sm mt-1'
                />
              </div>
              <button
                type='submit'
                className='w-full px-4 py-2  text-white font-medium bg-[#3d65d4] hover:bg-[#3f5eb5] active:bg-[#3357ba] rounded-lg duration-150 mt-8 mb-2'
              >
                Sign in
              </button>
              <div className='text-center'>
                <Link
                  to='/'
                  className='text-blue-500 no-underline hover:underline'
                >
                  Go back ?
                </Link>
              </div>

              {loading && <Spinner asOverlay={true} />}
            </Form>
          </div>
        )}
      </Formik>
    </main>
  );
};
export default AdminSignIn;
